// components/layout/services-ui/category-list.jsx
'use client';

import { DynamicIcon } from 'lucide-react/dynamic';

export default function CategoryList({ isLight, categories, activeCategory, setActiveCategory }) {
    const mutedText = isLight ? 'text-slate-500' : 'text-slate-400';
    const text = isLight ? 'text-slate-900' : 'text-white';
    const hover = isLight ? 'hover:bg-slate-100' : 'hover:bg-slate-800/60';
    const active = isLight ? 'bg-slate-100 text-slate-900' : 'bg-slate-800/70 text-white';
    const iconColor = isLight ? 'text-primary' : 'text-blue-300';

    return (
        <>
            <p className={`text-xs uppercase tracking-wider mb-3 ${mutedText}`}>Categories</p>
            <div className="flex flex-col gap-1">
                {categories.map((cat, i) => {
                    const isActive = i === activeCategory;
                    return (
                        <button
                            key={cat.title}
                            type="button"
                            onMouseEnter={() => setActiveCategory(i)}
                            onFocus={() => setActiveCategory(i)}
                            onClick={() => setActiveCategory(i)}
                            className={`w-full flex items-center gap-3 rounded-xl px-3 py-2 text-left transition ${
                                isActive ? active : `${text} ${hover}`
                            }`}
                        >
                            <DynamicIcon name={cat.icon} className={`w-5 h-5 ${iconColor}`} />
                            <span className="font-medium">{cat.title}</span>
                        </button>
                    );
                })}
            </div>
        </>
    );
}
